<template>
  <v-container fluid :class="`py-${height}`"></v-container>
</template>

<script>
export default {
  name: 'SpaceHorizontal',
  components: {
    //
  },
  props: {
    height: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      //
    };
  },
  methods: {
    //
  },
};
</script>

<style scoped>

</style>
